import { Breadcrumb, Col, Row, Typography } from 'antd';
import { SittingCard } from '../components/sitting/SittingCard.tsx';
import { getMySittingSchedules } from '../lib/api-client.ts';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

export const SittingsPage = () => {
  const { data } = useQuery({ queryKey: ['sittings'], queryFn: getMySittingSchedules });

  return (
    <>
      <Breadcrumb
        style={{ margin: 16 }}
        items={[{ title: <Link to="/">ホーム</Link> }, { title: 'シッティング' }]}
      />
      <Row gutter={[16, 16]} style={{ margin: 16 }}>
        {data && data.length !== 0 ? (
          data.map((sittingSchedule) => (
            <Col key={sittingSchedule.id} span={24}>
              <SittingCard sittingSchedule={sittingSchedule} />
            </Col>
          ))
        ) : (
          <Typography.Text>シッティング予定はありません。</Typography.Text>
        )}
      </Row>
    </>
  );
};
